import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { CustomerPOCModel } from "../../models/CustomerPOCModel";
import CustomerPOCService from "../../services/CustomerPOCService";
import CustomerPOCSlice from "../slices/CustomerPOCSlice";
import { RootState } from "../store";

export const actions = CustomerPOCSlice.actions;
export const fetchProjectCustomerPOCs = (
  projectId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: CustomerPOCModel[] =
      await CustomerPOCService.getAllProjectCustomerPOCs(projectId);
    dispatch(actions.setCustomerPOCs(response));
  };
};

export const setBidCreationCustomerPOCs = (
  data: CustomerPOCModel[]
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(actions.setBidCreationCustomerPOCs(data));
  };
};
